<template>
  <b-container class="wrap-archive">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="box-breadcrumb"
      >
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="box-back-btn"
      >
        <button @click.prevent="goBack()">
          Back to archive
        </button>
      </b-col>
    </b-row>

    <div v-if="!archive" class="loading">
      <pulse-loader
        :loading="true"
        color="#000000"
        class="loader"
      />
    </div>

    <b-row v-if="archive" class="wrap-content">
      <div class="box-youtube">
        <div class="container">
          <b-carousel
            :interval="999999999"
            controls
            indicators
          >
            <b-carousel-slide
              v-for="(youtube, youtubeIndex) in archive.youtube_link"
              :key="youtubeIndex + 100"
            >
              <template v-slot:img>
                <div class="youtube">
                  <iframe
                    width="100%"
                    height="100%"
                    :src="`https://www.youtube.com/embed/${youtube.split('/')[youtube.split('/').length - 1]}`"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
              </template>
            </b-carousel-slide>

            <div v-if="categoryName !== 'film'">
              <b-carousel-slide
                v-for="(image, imageIndex) in archive.image"
                :key="imageIndex"
              >
                <template v-slot:img>
                  <div class="image">
                    <img :src="image" >
                  </div>
                </template>
              </b-carousel-slide>
            </div>
          </b-carousel>
        </div>
      </div>

      <div class="box-list">
        <table>
          <tr>
            <td class="title">
              <div class="box"/>
              <p>Award</p>
            </td>
            <td
              v-if="archive.level.toLowerCase() === 'gold'"
              class="dec"
              :style="true ? { color: '#F7DC63', fontWeight: '800' } : {}"
            >
              <span v-html="archive.level" />
            </td>
            <td
              v-if="archive.level.toLowerCase() === 'silver'"
              class="dec"
              :style="true ? { color: '#C2BAA6', fontWeight: '800' } : {}"
            >
              <span v-html="archive.level" />
            </td>
            <td
              v-if="archive.level.toLowerCase() === 'bronze'"
              class="dec"
              :style="true ? { color: '#F4B04D', fontWeight: '800' } : {}"
            >
              <span v-html="archive.level" />
            </td>
            <td
              v-if="archive.level.toLowerCase() === 'finalist'"
              class="dec"
              :style="true ? { color: '#cccccc', fontWeight: '800' } : {}"
            >
              <span v-html="archive.level" />
            </td>
            <td
              v-if="archive.level.toLowerCase() === 'best'"
              class="dec"
              :style="true ? { color: '#E10100', fontWeight: '800' } : {}"
            >
              <span v-html="archive.level" />
            </td>
          </tr>
          <tr v-if="archive.subcategory !== 'AD THAT WORKS (EFFECTIVE COMMUNICATION)' && archive.subcategory !== 'INTEGRATED MARKETING COMMUNICATION (IMC)' && archive.subcategory !== 'INNOVATION' && archive.subcategory !== 'THE ONE'">
            <td class="title">
              <div class="box"/>
              <p>Sub-category</p>
            </td>
            <td class="dec">
              <span v-html="archive.subcategory" />
            </td>
          </tr>
          <tr>
            <td class="title">
              <div class="box"/>
              <p>Entry title</p>
            </td>
            <td class="dec">
              <span v-html="archive.name" />
            </td>
          </tr>
          <tr>
            <td class="title">
              <div class="box"/>
              <p>Brand</p>
            </td>
            <td class="dec">
              <span v-if="archive.id === 269" class="brand" v-html="archive.brand" />
              <span v-else v-html="archive.brand" />
            </td>
          </tr>
          <tr>
            <td class="title">
              <div class="box"/>
              <p>Advertiser</p>
            </td>
            <td class="dec">
              <span v-html="archive.advertiser" />
            </td>
          </tr>
          <tr>
            <td class="title">
              <div class="box"/>
              <p>Advertising agency</p>
            </td>
            <td class="dec">
              <span v-html="archive.agency" />
            </td>
          </tr>
          <tr v-if="archive.production_company">
            <td class="title">
              <div class="box"/>
              <p>Production company</p>
            </td>
            <td class="dec">
              <span v-html="archive.production_company" />
            </td>
          </tr>
        </table>
      </div>
    </b-row>

    <!-- rawArchives[0].subcategory[0].achive[0] -->
    <b-row v-if="relates.length !== 0" class="wrap-other">
      <h3 class="title">ผลงานอื่นๆที่เกี่ยวข้อง</h3>

      <div class="box-card">
        <b-row style="margin-left: 0; margin-right: 0;">
          <b-col
            v-for="relate in relates"
            :key="relate.id"
            :sm="12"
            :md="6"
            :lg="4"
            class="box-section"
          >
            <div
              @mouseover="hoverCard(relate.id, true)"
              @mouseleave="hoverCard(relate.id, false)"
            >
              <!-- <router-link :to="`/archive/winner/${year}/${categoryName}/${relate.name}?id=${relate.id}`"> -->
              <router-link
                :to="{
                  name: 'winnerArchiveDetail',
                  params: {
                    year,
                    categoryName,
                    name: relate.name.toLowerCase().replace(/<[^>]*>?/gm, '')
                  },
                  query: {
                    id: relate.id
                  }
                }"
              >
                <div class="wrap-image">
                  <img
                    :src="`${relate.image}`"
                    :alt="relate.name"
                  >
                  <div
                    :class="isHover && relate.id === showDec ? 'box-dec-wrapper box-dec-wrapper--open' : 'box-dec-wrapper box-dec-wrapper--close'"
                  >
                    <div class="box-wrapper">
                      <div class="rank">
                        <div class="text">
                          <div
                            class="tab"
                            :style="[
                              relate.level.toLowerCase() === 'gold' ? { backgroundColor: '#f7dc63' } : {},
                              relate.level.toLowerCase() === 'silver' ? { backgroundColor: '#c2baa6' } : {},
                              relate.level.toLowerCase() === 'bronze' ? { backgroundColor: '#f4b04d' } : {},
                              relate.level.toLowerCase() === 'best' ? { backgroundColor: '#E10100' } : {}
                            ]"
                          >
                            <p>{{ relate.level }}</p>
                          </div>
                          <p
                            class="title"
                            :style="[
                              relate.level.toLowerCase() === 'gold' ? { color: '#f7dc63' } : {},
                              relate.level.toLowerCase() === 'silver' ? { color: '#c2baa6' } : {},
                              relate.level.toLowerCase() === 'bronze' ? { color: '#f4b04d' } : {},
                              relate.level.toLowerCase() === 'best' ? { color: '#E10100' } : {}
                            ]"
                          >
                            Award
                          </p>
                        </div>
                      </div>

                      <div class="content">
                        <h3 v-html="relate.name" class="title" />

                        <div class="detail">
                          <!-- <div class="box" /> -->
                          <p v-if="relate.id === 269" class="text brand" v-html="relate.brand" />
                          <p v-else class="text" v-html="relate.brand" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

// const Title = () => import('@/components/About/Parts/Title')
// const Card = () => import('@/components/Archive/Parts/Card')

export default {
  data () {
    return {
      showDec: null,
      isHover: true,
      archive: null,
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Winner Archive',
          to: {
            name: 'winnerArchive'
          }
        },
        {
          text: this.$route.params.categoryName.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase()),
          to: {
            name: 'winnerArchiveCategory',
            params: {
              year: this.$route.params.year,
              categoryName: this.$route.params.categoryName.toLowerCase()
            }
          }
        },
        {
          // text: this.$route.params.name.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase())
          text: this.$route.params.name.toUpperCase().replace(/<[^>]*>?/gm, '')
        }
      ],
      relates: []
    }
  },

  computed: {
    ...mapState({
      categories: state => state.archive.categorys,
      subCategories: state => state.archive.subcategory,
      rawDetail: state => state.archive.detail
    }),

    year () {
      return this.$route.params.year
    },

    categoryName () {
      return this.$route.params.categoryName
    }
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  },

  watch: {
    categories (categories) {
      if (categories) {
        this.mapCategories(categories)
      }
    },

    subCategories (subCategories) {
      if (subCategories) {
        subCategories.forEach((a) => {
          console.log(this.$route.query.id)
          if (
            a.id.toString() === this.$route.query.id.toString() &&
            a.name.toLowerCase().replace(/<[^>]*>?/gm, '') === decodeURI(this.$route.params.name).toLowerCase().replace(/<[^>]*>?/gm, '')
          ) {
            this.$store.dispatch('archive/getDetail', {
              id: a.id,
              categoryId: a.category[0].id
            })
          }
        })
      }
    },

    rawDetail (detail) {
      if (detail.length !== 0) {
        console.log(detail.archive)
        this.archive = {
          id: detail.archive.id,
          image: detail.archive.image,
          name: detail.archive.name,
          youtube_link: detail.archive.youtube_link,
          level: detail.archive.level,
          subcategory: detail.archive.subcategory,
          brand: detail.archive.brand,
          advertiser: detail.archive.advertiser,
          agency: detail.archive.agency,
          production_company: detail.archive.production_company
        }

        this.relates = detail.relate
      }
    },

    '$route' () {
      this.archive = null
      this.relates = []

      if (!this.categories) {
        this.$store.dispatch('archive/getCate')
      } else {
        this.mapCategories(this.categories)
      }

      this.breadcrumbs = [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Winner Archive',
          to: {
            name: 'winnerArchive'
          }
        },
        {
          text: this.$route.params.categoryName.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase()),
          to: {
            name: 'winnerArchiveCategory',
            params: {
              year: this.$route.params.year,
              categoryName: this.$route.params.categoryName.toLowerCase()
            }
          }
        },
        {
          // text: this.$route.params.name.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase())
          text: this.$route.params.name.toUpperCase()
        }
      ]
    }
  },

  created () {
    if (!this.categories) {
      this.$store.dispatch('archive/getCate')
    } else {
      this.mapCategories(this.categories)
    }
  },

  methods: {
    hoverCard (index, status) {
      this.isHover = status

      if (status) {
        this.showDec = index
      } else {
        this.showDec = null
      }
    },

    goBack () {
      this.$router.push({
        name: 'winnerArchiveCategory',
        params: {
          year: this.year,
          categoryName: this.categoryName.toLowerCase()
        }
      })
    },

    mapCategories (categories) {
      if (categories) {
        categories.forEach((category) => {
          if (category.name.toLowerCase() === this.categoryName.toLowerCase()) {
            this.$store.dispatch('archive/getList', category.id)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-archive {
  .box-head {
      padding: 22px 0;
      border-bottom: 1px solid #CCC;

      .box-breadcrumb {
        display: flex;
        align-items: center;

        .breadcrumb {
          margin: 0;
          padding: 0;
          background: none;

          li {
            font-size: 1.25rem;

            a {
              color: black;
            }
          }
        }
      }

      .box-back-btn {
        margin-top: 22px;

        @media only screen and (min-width: $break-m) {
          margin-top: 0;
        }

        button {
          width: 100%;
          background-color: #CCC;
          padding: 12px 0;
          font-size: 1.25rem;
        }
      }
    }

  .wrap-content {
    padding-bottom: 12px;

    .box-youtube {
      margin-top: 22px;
      width: 100%;

      .carousel-indicators {
        margin-bottom: 100px !important;
      }

      .image {

        img {
          width: 100%;
          top: 0;
          left: 0;
          height: 100%;
          padding-bottom: 42px;
          padding-left: 15px;
          padding-right: 15px;
        }
      }

      .youtube {
        position: relative;
        width: 100%;
        padding-bottom: 56.25%;

        img,
        iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          padding-bottom: 42px;
          padding-left: 15px;
          padding-right: 15px;
        }
      }
    }

    // .box-youtube {
    //   overflow: hidden;
    //   position: relative;
    //   width: 100%;
    //   margin-top: 22px;
    //   padding-bottom: calc(56.25% + 42px);
    //   border-bottom: 1px solid #CCC;
    // }

    .box-list {
      display: flex;
      justify-content: center;
      padding-top: 22px;
      padding-bottom: 22px;
      width: 100%;

      table {
        width: 80%;
        text-transform: uppercase;

        tr {
          display: flex;
          flex-direction: column;
          font-weight: 800;
          font-size: 28px;
          letter-spacing: 0.5px;

          @media only screen and (min-width: $break-m) {
            flex-direction: row;
          }

          .title {
            display: flex;
            align-items: center;
            width: 95%;
            height: 53px;
            font-family: 'DB Helvethaica X Med Cond';
            color: #BCBEC0;

            .box {
              width: 14px;
              height: 14px;
              background-color: #E10100;
            }

            p {
              margin-top: 2px;
              margin-left: 12px;
            }
          }

          .dec::before {
            content: ':';
            margin-right: 12px;
            font-size: 34px;
            font-weight: 800;
            color: #979697;
          }

          .dec {
            display: flex;
            padding-left: 28px;
            width: 100%;
            font-family: 'DB Helvethaica X 67 Cond';
            font-weight: 300;
            color: #979697;
            .brand {
              font-family: 'Roboto';
              font-size: 20px;
              line-height: 40px;
            }
            span {
              padding-top: 6px;
            }
          }
        }
      }
    }
  }

  .wrap-other {
    border-top: 10px solid #D1D3D4;

    > .title {
      padding-top: 22px;
      padding-bottom: 22px;
      width: 100%;
      font-family: 'DB HelvethaicaMon X';
      text-align: center;
      font-size: 28px;
    }

    .box-card {
      width: 100%;

      .box-section {
        margin-bottom: 32px;
        width: 100%;
        height: fit-content;

        a {
          .wrap-image {
            overflow: hidden;
            position: relative;
            width: 100%;
            padding-bottom: 56.25%;

            img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: #ccc;
            }

            .box-dec-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            padding: 18px;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.85);

            .box-wrapper {
              position: relative;
              width: 100%;
              height: 100%;
              padding: 12px;
              border: 3px solid white;
            }

            .rank {
              overflow: hidden;
              position: absolute;
              right: 0;
              top: 0;
              height: 100%;

              .text {
                display: flex;

                .tab {
                  width: 25px;
                  height: 80px;
                  transform: translateX(24px);
                  margin-right: 8px;
                  font-family: 'DB Helvethaica X 67 Cond';
                  font-weight: 800;
                  font-size: 140px;
                  background-color: #ccc;

                  p {
                    transform: rotate(-90deg) translate(-46px, 2px);
                    top: 12px;
                    white-space: nowrap;
                    text-align: left;
                    text-transform: uppercase;
                    font-family: 'DB Helvethaica X 67 Cond';
                    font-size: 22px;
                    font-weight: 800;
                    color: #231F20;
                  }
                }

                .title {
                  transform: rotate(-90deg) translateX(-90px);
                  margin-top: -62px;
                  margin-right: -16px;
                  width: fit-content;
                  height: fit-content;
                  text-transform: uppercase;
                  font-size: 26px;
                  color: #ccc;
                }
              }
            }

            .content {
              width: 80%;
              height: 100%;

              .title {
                width: 100%;
                overflow: hidden;
                margin-left: 12px;
                text-overflow: ellipsis;
                text-transform: uppercase;
                font-family: 'DB Helvethaica X Med Cond';
                font-size: 24px;
                line-height: 26px;
                color: #C69C35;
              }

              .detail {
                display: -webkit-box;
                margin-top: 6px;

                .box {
                  margin-top: 6px;
                  width: 10px;
                  height: 10px;
                  background-color: #E10100;
                }

                .text {
                  overflow: hidden;
                  margin-left: 12px;
                  text-overflow: ellipsis;
                  font-family: 'DB Helvethaica X Li v3.2';
                  line-height: 21px;
                  font-size: 22px;
                  color: white;
                }

                .text.brand {
                  font-family: 'Roboto';
                  font-size: 16px;
                  line-height: 22px;
                }
              }
            }
          }

          .box-dec-wrapper--open {
            animation: open 300ms ease-out forwards;

            @keyframes open {
              from {
                transform: translateX(-100%);
              }

              to {
                transform: translateX(0);
              }
            }
          }

          .box-dec-wrapper--close {
            animation: close 200ms ease-out forwards;

            @keyframes close {
              from {
                transform: translateX(0);
              }

              to {
                transform: translateX(-100%);
              }
            }
          }
          }
        }
      }
    }
  }
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
}
</style>
